/*!
 * accounting.js v0.4.2, copyright 2014 Open Exchange Rates, MIT license, http://openexchangerates.github.io/accounting.js
 */
(function(p,z){function q(a){return!!(""===a||a&&a.charCodeAt&&a.substr)}function m(a){return u?u(a):"[object Array]"===v.call(a)}function r(a){return"[object Object]"===v.call(a)}function s(a,b){var d,a=a||{},b=b||{};for(d in b)b.hasOwnProperty(d)&&null==a[d]&&(a[d]=b[d]);return a}function j(a,b,d){var c=[],e,h;if(!a)return c;if(w&&a.map===w)return a.map(b,d);for(e=0,h=a.length;e<h;e++)c[e]=b.call(d,a[e],e,a);return c}function n(a,b){a=Math.round(Math.abs(a));return isNaN(a)?b:a}function x(a){var b=c.settings.currency.format;"function"===typeof a&&(a=a());return q(a)&&a.match("%v")?{pos:a,neg:a.replace("-","").replace("%v","-%v"),zero:a}:!a||!a.pos||!a.pos.match("%v")?!q(b)?b:c.settings.currency.format={pos:b,neg:b.replace("%v","-%v"),zero:b}:a}var c={version:"0.4.1",settings:{currency:{symbol:"$",format:"%s%v",decimal:".",thousand:",",precision:2,grouping:3},number:{precision:0,grouping:3,thousand:",",decimal:"."}}},w=Array.prototype.map,u=Array.isArray,v=Object.prototype.toString,o=c.unformat=c.parse=function(a,b){if(m(a))return j(a,function(a){return o(a,b)});a=a||0;if("number"===typeof a)return a;var b=b||".",c=RegExp("[^0-9-"+b+"]",["g"]),c=parseFloat((""+a).replace(/\((.*)\)/,"-$1").replace(c,"").replace(b,"."));return!isNaN(c)?c:0},y=c.toFixed=function(a,b){var b=n(b,c.settings.number.precision),d=Math.pow(10,b);return(Math.round(c.unformat(a)*d)/d).toFixed(b)},t=c.formatNumber=c.format=function(a,b,d,i){if(m(a))return j(a,function(a){return t(a,b,d,i)});var a=o(a),e=s(r(b)?b:{precision:b,thousand:d,decimal:i},c.settings.number),h=n(e.precision),f=0>a?"-":"",g=parseInt(y(Math.abs(a||0),h),10)+"",l=3<g.length?g.length%3:0;return f+(l?g.substr(0,l)+e.thousand:"")+g.substr(l).replace(/(\d{3})(?=\d)/g,"$1"+e.thousand)+(h?e.decimal+y(Math.abs(a),h).split(".")[1]:"")},A=c.formatMoney=function(a,b,d,i,e,h){if(m(a))return j(a,function(a){return A(a,b,d,i,e,h)});var a=o(a),f=s(r(b)?b:{symbol:b,precision:d,thousand:i,decimal:e,format:h},c.settings.currency),g=x(f.format);return(0<a?g.pos:0>a?g.neg:g.zero).replace("%s",f.symbol).replace("%v",t(Math.abs(a),n(f.precision),f.thousand,f.decimal))};c.formatColumn=function(a,b,d,i,e,h){if(!a)return[];var f=s(r(b)?b:{symbol:b,precision:d,thousand:i,decimal:e,format:h},c.settings.currency),g=x(f.format),l=g.pos.indexOf("%s")<g.pos.indexOf("%v")?!0:!1,k=0,a=j(a,function(a){if(m(a))return c.formatColumn(a,f);a=o(a);a=(0<a?g.pos:0>a?g.neg:g.zero).replace("%s",f.symbol).replace("%v",t(Math.abs(a),n(f.precision),f.thousand,f.decimal));if(a.length>k)k=a.length;return a});return j(a,function(a){return q(a)&&a.length<k?l?a.replace(f.symbol,f.symbol+Array(k-a.length+1).join(" ")):Array(k-a.length+1).join(" ")+a:a})};if("undefined"!==typeof exports){if("undefined"!==typeof module&&module.exports)exports=module.exports=c;exports.accounting=c}else"function"===typeof define&&define.amd?define([],function(){return c}):(c.noConflict=function(a){return function(){p.accounting=a;c.noConflict=z;return c}}(p.accounting),p.accounting=c)})(this);

function isSafariBrowser(){
    let result = false;
    if (navigator.userAgent.match(/AppleWebKit/) && !navigator.userAgent.match(/Chrome/)) {
        result = true;
    }
    return result;
}

function setHeaderBreadcrumbsPosition(){
        let tickerSection = document.querySelector('.ticker-section');
        let announcementSection = document.querySelector('.announcement-section');
        let getHeight = (element) => {
            return element ? element.offsetHeight : 0;
        };
        
        let tickerHeight = getHeight(tickerSection);

        let announcementHeight = getHeight(announcementSection);

        if(announcementHeight > 0 && tickerHeight > 0){
            tickerSection.style.top = announcementHeight + 'px';
        }
        let totalHeight = tickerHeight + announcementHeight;
        let headerMenu = document.querySelector('.header-main');
        let breadcrumbs = document.querySelector('.breadcrumbs-section');
        let teaser = document.querySelector('.teaser[data-menu-top-margin="true"]');
        
        if (headerMenu) {
            let headerMenuHeight = getHeight(headerMenu);
            let countCombinetHeight = totalHeight + headerMenuHeight;
            let combinedHeight = countCombinetHeight < 200 ? countCombinetHeight : 132;

            headerMenu.style.top = totalHeight + 'px';
            if(teaser){
                teaser.style.marginTop = combinedHeight + 'px';
                teaser.style.opacity = 1;
            }

            if(breadcrumbs){
                breadcrumbs.style.marginTop = combinedHeight + 'px';
            }
        }

        let announcementSlider = document.querySelector('.announcement-slider');
        if(announcementSlider){
            announcementSlider.classList.remove('opacity-0');
        }
}

function setTeaserOpacity(){
    let teaser = document.querySelector('.teaser[data-menu-top-margin="true"]');
    if(teaser){
        teaser.style.opacity = 1;
    }
}

function setHeaderFixedPosition(){
    const headerMain = document.getElementById('header-main');
    headerMain.classList.add('sc-fixed');
}

// document.addEventListener('scroll', function(){
//     setHeaderFixedPosition();
// });

jQuery(document).ready(function () {

    console.dir(`app.js v8.3`);

    /* Add Safari Styles */
      if (isSafariBrowser()) {
        jQuery('body').addClass('safari-browser');
      }
    /* Add Safari Style END */

    /* Measure landing */
    if(jQuery('.measure-landing-section').length){
        
        //Function to enforce minimum and maximum values
        function enforceMinMax(inputElement) {
            let min = parseInt(inputElement.getAttribute('min'));
            let max = parseInt(inputElement.getAttribute('max'));
            inputElement.addEventListener('input', () => {
            let value = parseInt(inputElement.value);
            if (isNaN(value)) return;
            if (value > max ) {
                inputElement.value = max;
            } 
            else if (value < min) {
                // inputElement.value = min;
            }
            });
        }
        //Get all input elements with the class "l-measure__input"
        let inputs = document.querySelectorAll('.l-measure__input');
        //Enforce min/max for each input element
        inputs.forEach((input) => {
            enforceMinMax(input);
        });

        //Get size code...

        function updateSizeImage(size, this_obj){
            let parent = jQuery(this_obj).closest('.l-measure');
            let dataStr = 'data-img-' + size;
            let imgUrl = parent.find('.l-measure__size-icon').attr(dataStr);
            parent.find('.l-measure__size-icon-img').attr('src', imgUrl);
        }
        
        function showSize(size, this_obj){
            console.dir(`function showSize(size, this_obj){`);

            let parent = jQuery(this_obj).closest('.l-measure');
            
            parent.find('.l-measure__phrase-block').addClass('hide');
            
            updateSizeImage(size, this_obj);
            size = size.toUpperCase();
            parent.find('.l-measure__size').text(size);
            parent.find('.l-measure__result-block').removeClass('hide');
        }

        function goBack(this_obj){
           let parent = jQuery(this_obj).closest('.l-measure');
           parent.find('.l-measure__result-block').addClass('hide');
           parent.find('.l-measure__fail-block').addClass('hide');
           parent.find('.l-measure__phrase-block').removeClass('hide');
        }

        function showUnAvailable(this_obj){
            let parent = jQuery(this_obj).closest('.l-measure');
            parent.find('.l-measure__phrase-block').addClass('hide');
            parent.find('.l-measure__fail-block').removeClass('hide');
            setTimeout(function(){
                goBack(this_obj);
            }, 1500);
        }


        function getSizesTableObj(){
            // let jsonSizeTableString = '[{"weight": 8, "backLengthMin": 8, "backLengthMax": 10, "girthMin": 12, "girthMax": 15, "size": "XXS"},{"weight": 12, "backLengthMin": 10, "backLengthMax": 12, "girthMin": 15, "girthMax": 18, "size": "XS"},{"weight": 17, "backLengthMin": 12, "backLengthMax": 14, "girthMin": 16, "girthMax": 20, "size": "S"},{"weight": 25, "backLengthMin": 13, "backLengthMax": 16, "girthMin": 20, "girthMax": 24, "size": "M"},{"weight": 35, "backLengthMin": 16, "backLengthMax": 20, "girthMin": 22, "girthMax": 26, "size": "L"},{"weight": 48, "backLengthMin": 20, "backLengthMax": 23, "girthMin": 24, "girthMax": 28, "size": "XL"},{"weight": 58, "backLengthMin": 24, "backLengthMax": 28, "girthMin": 26, "girthMax": 32, "size": "XXL"}]';
            let jsonSizeTableString = jQuery('.l-measure__size-data').text().trim();
            console.dir(`jsonSizeTableString`);console.dir(jsonSizeTableString);

            let jsonSizeTable = JSON.parse(jsonSizeTableString);
            console.dir(`jsonSizeTable`);console.dir(jsonSizeTable);

            return jsonSizeTable;
        }

        function getSize(weight, backLength, girth) {
            console.dir(`function getSize(weight, backLength, girth) {`);

            console.dir(`weight`);console.dir(weight);
            console.dir(`backLength`);console.dir(backLength);
            console.dir(`girth`);console.dir(girth);

            let jsonSizeTable = getSizesTableObj();

            for (var i = 0; i < jsonSizeTable.length; i++) {
                console.dir(`1 - for (var i = 0; i < jsonSizeTable.length; i++) {`);
                console.dir(`i`);console.dir(i);
                console.dir(`weight`);console.dir(weight);
                console.dir(`jsonSizeTable[i].weight`);console.dir(jsonSizeTable[i].weight);
                if(weight <= jsonSizeTable[i].weight){
                    console.dir(`if(weight <= jsonSizeTable[i].weight){`);
                    
                    let size = jsonSizeTable[i].size;
                    size = size.toLowerCase();
                    console.dir(`size - 1`);console.dir(size);
                    return size;
                }
            }

            for (var j = 0; j < jsonSizeTable.length; j++) {
                console.dir(`2 - for (var j = 0; j < jsonSizeTable.length; j++) {`);
                console.dir(`j`);console.dir(j);

                console.dir(`girth`);console.dir(girth);
                console.dir(`backLength`);console.dir(backLength);

                    if ( (jsonSizeTable[j].girthMin <= girth && girth <= jsonSizeTable[j].girthMax) && 
                         (jsonSizeTable[j].backLengthMin <= backLength && backLength <= jsonSizeTable[j].backLengthMax) ) {

                            console.dir(`if ( (jsonSizeTable[j].girthMin <= girth && girth <= jsonSizeTable[j].girthMax) && (jsonSizeTable[j].backLengthMin <= backLength && backLength <= jsonSizeTable[j].backLengthMax) ) {`);

                        let size = jsonSizeTable[j].size;
                            size = size.toLowerCase();
                            console.dir(`size - 2`);console.dir(size);
                            return size;
                    }
            }
            
            return false;
        }

        function stringToFloat(str){
            console.dir(`function stringToFloat(str){`);

            str = str.replace(/[^0-9.,]/g, '');
            str = str.replace(',', '.');
            let result = parseFloat(str);
            console.dir(`result`);console.dir(result);

            return result;
          }

        function getFormParams(this_obj){
            let parent = jQuery(this_obj).closest('.l-measure');

            let weight = parent.find('.l-measure__weigh').val();
            console.dir(`weight`);console.dir(weight);
            let backLength = parent.find('.l-measure__back-length').val();
            console.dir(`backLength`);console.dir(backLength);
            let girth = parent.find('.l-measure__girth-size').val();
            console.dir(`girth`);console.dir(girth);

            let paramsObj = new Object();
            if(weight){
                paramsObj.weight = stringToFloat(weight);
            } else {
                paramsObj.weight = 100000;
                console.dir(`paramsObj.weight = 100000;`);
            }

            if(backLength){
                paramsObj.backLength = stringToFloat(backLength);
            } else {
                paramsObj.backLength = 100000;
                console.dir(`paramsObj.backLength = 100000;`);
            }
            
            if(girth){
                paramsObj.girth = stringToFloat(girth);
            } else {
                paramsObj.girth = 100000;
                console.dir(`paramsObj.girth = 100000;`);
            }
            
            console.dir(`paramsObj`);console.dir(paramsObj);
            return paramsObj;
        }

        jQuery('body').on('click', '.l-measure__btn-show-size', function(){
            console.dir(`jQuery('body').on('click', '.l-measure__btn-show-size', function(){`);

            let paramsObj = getFormParams(this);
            let weight = paramsObj.weight;
            console.dir(`weight`);console.dir(weight);

            let backLength = paramsObj.backLength;
            let girth = paramsObj.girth;

            let size = getSize(weight, backLength, girth);
            console.dir(`size`);console.dir(size);

            if(size){
                showSize(size, this);
            } else {
                showUnAvailable(this);
            }
        });

        jQuery('body').on('click', '.l-measure__btn-back', function(){
            goBack(this);
        });

    }

    jQuery('body').on('click', '.show-tag', function(){
          jQuery(this).toggleClass('UGC_on__2QzPe');
          jQuery(this).parent().toggleClass('UGC_on__2QzPe');
      });

    if (document.documentElement.clientWidth < 992) {
        jQuery('body').on('click', '.main-menu__parrent', function(){
            jQuery(this).toggleClass('opened');
        });
    }

    /*Преобразование img в svg*/
    function imgToSvgConvert(element) {
        var img = jQuery(element);
        var imgID = img.attr('id');
        var imgClass = img.attr('class');
        var imgURL = img.attr('src');
        jQuery.get(imgURL, function (data) {
            // Get the SVG tag, ignore the rest
            var svg = jQuery(data).find('svg');
            // Add replaced image's ID to the new SVG
            if (typeof imgID !== 'undefined') {
                svg = svg.attr('id', imgID);
            }
            // Add replaced image's classes to the new SVG
            if (typeof imgClass !== 'undefined') {
                svg = svg.attr('class', imgClass + ' replaced-svg');
            }
            // Remove any invalid XML tags as per http://validator.w3.org
            svg = svg.removeAttr('xmlns:a');
            // Replace image with new SVG
            img.replaceWith(svg);
        }, 'xml');
    }

    if(jQuery('.text-regular .hide-it-for-description').length) {
        let html = jQuery('.text-regular .hide-it-for-description').html();
        /*console.log('html: ' + html);*/
        jQuery('.accordion #accordion-item-details .accordion-body').html(html);
        jQuery('.accordion #accordion-item-details').show();
    }

    function renderModalCart(html, callback) {
        // console.dir(`html`);console.dir(html);
        document.getElementById('ModalCart').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ModalCart').innerHTML;
        // document.getElementById('cartIconCount').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('cartIconCount').innerHTML;
        // document.getElementById('cartIconCountMob').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('cartIconCountMob').innerHTML;
        callback();
    }

    function liveUpdateBlockById(html, selectorId, callback) {
        document.getElementById(selectorId).innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById(selectorId).innerHTML;
        callback();
    }

    function renderSectionFromFetchById(url, selectorId, finalCallback, callback) {
        fetch(url)
          .then(response => response.text())
          .then((responseText) => {
            const html = responseText;
            callback(html, selectorId, finalCallback);
          });
    }

    function renderSectionFromFetch(url, callback) {
        fetch(url)
          .then(response => {
            if (response.ok) {
                return response.text();
            } else {
                return false;
            }
        })
          .then((responseText) => {
                const html = responseText;
                callback(html, hideLoader);
          }).catch(error => {
            //Error
        });
    }

    function updateModalCart() {
        let url = window.location.origin;
        renderSectionFromFetch(url, renderModalCart);
    }

    function showLoader() {
        jQuery('.custom-loader').removeClass('hide');
    }
    function hideLoader() {
        jQuery('.custom-loader').addClass('hide');
    }

    function showSearchLoader() {
        jQuery('.loader-search').removeClass('hide');
    }
    function hideSearchLoader() {
        jQuery('.loader-search').addClass('hide');
    }

    function showCartPopup(callback){
        console.log('showCartPopup');
        // jQuery('.form-cart').addClass('open');
        // jQuery('.inner-div').addClass('slide-left');
        // jQuery('body').addClass('no-scroll');

        /*
        var top = window.pageYOffset || document.documentElement.scrollTop;
        jQuery('.custom-loader').css("top", top + 240 + "px");
        showLoader();
        var formName = 'form-cart';
        var width = jQuery('.' + formName).outerWidth();
        var left = (jQuery(window).width() - width) / 2;
        jQuery('.' + formName).css("right", 0 + "px");
        jQuery('.' + formName).css("top", top + "px");
        
        jQuery('.inner-div').addClass('blur');
        jQuery('.bg-gray-popup').fadeIn(400);
        jQuery('.' + formName).fadeIn(400);*/

        callback();
    }

    function changeOpenedCartPopup(callback){
        console.dir(`function changeOpenedCartPopup(callback){`);
        var top = window.pageYOffset || document.documentElement.scrollTop;
        showLoader();
        callback();
    }

    function changeRemoveCartTable(response) {
        /*console.dir(`changeRemoveCartTable`);*/
        if (typeof(response) != "undefined" && response !== null && response != 'fail') {
            /*console.dir(jQuery('.cart-items tbody .cart-item').length);*/
            if (jQuery('.cart-items tbody .cart-item').length) {
                let currency = response.currency;
                let currency_symbol = jQuery('.cart-items').data('currency-symbol');
                jQuery('.cart-items tbody tr').each(function (index, value) {
                    let zero_final_line_price = accounting.formatMoney('0', currency_symbol, 2, ",", ".")
                    /*console.dir(zero_final_line_price);*/
                    jQuery(this).find('.cart-item__totals .price').text(zero_final_line_price);
                });
                for (var i = 0; i < response.items.length; i++) {
                    /*console.dir(response.items[i].variant_id);*/
                    for (var j = 0; j < jQuery('.cart-items tbody tr').length; j++) {
                        let variant_id = jQuery('.cart-items tbody tr:eq('+j+') .cart-item__quantity').data('variant-id');
                        /*console.dir(variant_id);*/
                        if (response.items[i].variant_id == variant_id) {
                            let final_price = response.items[i].final_price;
                            final_price = parseFloat(final_price) / 100;

                            let final_line_price = response.items[i].final_line_price;
                            final_line_price = parseFloat(final_line_price) / 100;

                            if (final_price && currency) {
                                jQuery('.cart-items tbody tr:eq('+j+') .cart-item__price .price').text(accounting.formatMoney(final_price, currency_symbol, 2, ",", "."));
                            }

                            if (final_line_price && currency) {
                                jQuery('.cart-items tbody tr:eq('+j+') .cart-item__totals .price').text(accounting.formatMoney(final_line_price, currency_symbol, 2, ",", "."));
                            }
                        }
                    }

                }
                let total_price = response.total_price;
                total_price = parseFloat(total_price) / 100;
                jQuery('#main-cart-footer .totals .totals__subtotal-value').text(accounting.formatMoney(total_price, currency_symbol, 2, ",", ".") + ' ' + currency);
            }
        }
    }

    function changeAddCartTable(response) {
        /*console.dir(`changeAddCartTable`);*/
        if (typeof(response) != "undefined" && response !== null && response != 'fail') {
            /*console.dir(jQuery('.cart-items tbody .cart-item').length);*/
            if (jQuery('.cart-items tbody .cart-item').length) {
                let currency = jQuery('.cart-items').data('currency');
                let currency_symbol = jQuery('.cart-items').data('currency-symbol');

                let variant_id = response.variant_id;
                let cart_item = jQuery('.cart-items tbody .cart-item .cart-item__quantity[data-variant-id="'+variant_id+'"]').closest('.cart-item');

                let final_price = response.final_price;
                final_price = parseFloat(final_price) / 100;

                let final_line_price = response.final_line_price;
                final_line_price = parseFloat(final_line_price) / 100;

                if (final_price && currency) {
                    cart_item.find('.cart-item__price .price').text(accounting.formatMoney(final_price, currency_symbol, 2, ",", "."));
                }

                if (final_line_price && currency) {
                    cart_item.find('.cart-item__totals .price').text(accounting.formatMoney(final_line_price, currency_symbol, 2, ",", "."));
                }

                let total_price = 0;
                jQuery('.cart-items tbody .cart-item').each(function (index, value) {
                    let price_str = jQuery(this).find('.cart-item__price .price').text();
                    price_str = price_str.replace(/ /g,'');
                    price_str = price_str.substring(1);
                    let quantity = jQuery(this).find('.cart-item__quantity input.product-cnt').val();
                    /*console.dir(quantity);*/
                    let price_unformat = accounting.unformat(currency_symbol + ' ' + price_str + ' ' + currency);
                    total_price += parseFloat(price_unformat * quantity);
                });
                jQuery('#main-cart-footer .totals .totals__subtotal-value').text(accounting.formatMoney(total_price, currency_symbol, 2, ",", ".") + ' ' + currency);
            }
        }
    }


    function addToCartPost(data){
        var addToCartUrl = window.location.origin+'/cart/add.js';
          jQuery.ajax({
            type: 'POST',
            url: addToCartUrl,
            data: data,
            dataType: 'json',
            crossDomain: true,
            success: function(response) {
                console.dir(`response`);console.dir(response);
                //Обновим корзину и покажем всплывающее окно корзины
                if (jQuery('#cart').length) {
                    changeAddCartTable(response);
                } else {
                    showCartPopup(updateModalCart);
                }
            },
            error: function (jqXHR, exception) {
                console.dir('error function');

                var msg = '';
                if (jqXHR.status === 0) {
                    msg = 'Not connect.\n Verify Network.';
                } else if (jqXHR.status == 404) {
                    msg = 'Requested page not found. [404]';
                } else if (jqXHR.status == 500) {
                    msg = 'Internal Server Error [500].';
                } else if (exception === 'parsererror') {
                    msg = 'Requested JSON parse failed.';
                } else if (exception === 'timeout') {
                    msg = 'Time out error.';
                } else if (exception === 'abort') {
                    msg = 'Ajax request aborted.';
                } else {
                    msg = 'Uncaught Error.\n' + jqXHR.responseText;
                }
                console.dir('msg');
                console.dir(msg);
                console.dir('jqXHR');
                console.dir(jqXHR);
                console.dir('exception');
                console.dir(exception);
                // Your error handling logic here..
              }
          });
    }

    /* Добавим несколько товаров одним запросом */
    function addMultiItemsToCart(variantsArr, callback) {
        console.dir(` addMultiItemsToCart()`);
        let data = {
            "items": variantsArr
        };
        var formErr = false;
        if(formErr == false){
            jQuery('.form-error').removeClass('form-error');
            callback(data);
        }
    }
    /* Добавим несколько товаров одним запросом END */

    function addItemToCart(variant_id, qty=1, callback) {
        console.dir(`addItemToCart()`);

        let data = {
            "id": variant_id,
            "quantity": qty
          };


        /*
          let data = new Object();
            data["id"] = variant_id;
            data["quantity"] = qty;
        */

        var formErr = false;
        if(jQuery('.properties').length){
            var properties = new Object();
            jQuery('.properties').each(function() {
                var propertyName = jQuery(this).data('properties');
                var propertyValue = jQuery(this).val();
                var requiredField = jQuery(this).prop('required');
                if(requiredField && propertyValue.length < 2){
                    formErr = true;
                    jQuery(this).addClass('form-error');
                    document.getElementById('properties').scrollIntoView();
                }
                if(propertyValue.length > 0 && propertyName.length > 0){
                    properties[propertyName] = propertyValue;
                }
            });
            data["properties"] = properties;
        }

        if(formErr == false){
            jQuery('.form-error').removeClass('form-error');
            callback(data);
        }
    }

    function removeItemFromCart(variant_id, qty=1) {
        console.dir(`function removeItemFromCart(variant_id, qty=1) {`);

        if(qty>0){
            qty = qty - 1;
        }else {
            qty = 0;
        }

        console.dir(`qty`);console.dir(qty);

        let data = {
            'id': variant_id,
            'quantity': qty
          };
          console.dir(`data`);console.dir(data);

          jQuery.ajax({
            type: 'POST',
            url: '/cart/change.js',
            data: data,
            dataType: 'json',
            crossDomain: true,
            success: function(response) {
                console.dir(`response`);console.dir(response);
                //Обновим корзину и покажем всплывающее окно корзины
                if (jQuery('#cart').length) {
                    changeRemoveCartTable(response);
                } else {
                    changeOpenedCartPopup(updateModalCart);
                }
            },
            error: function (jqXHR, exception) {
                console.dir('error function');

                var msg = '';
                if (jqXHR.status === 0) {
                    msg = 'Not connect.\n Verify Network.';
                } else if (jqXHR.status == 404) {
                    msg = 'Requested page not found. [404]';
                } else if (jqXHR.status == 500) {
                    msg = 'Internal Server Error [500].';
                } else if (exception === 'parsererror') {
                    msg = 'Requested JSON parse failed.';
                } else if (exception === 'timeout') {
                    msg = 'Time out error.';
                } else if (exception === 'abort') {
                    msg = 'Ajax request aborted.';
                } else {
                    msg = 'Uncaught Error.\n' + jqXHR.responseText;
                }
                console.dir('msg');
                console.dir(msg);
                console.dir('jqXHR');
                console.dir(jqXHR);
                console.dir('exception');
                console.dir(exception);
                // Your error handling logic here..
              }
          });
    }

    function updateUrl(key, value){
        const urlParams = new URLSearchParams(window.location.search);
        if(value.length){
            urlParams.set(key, value);
        } else {
            urlParams.delete(key);
        }
        window.location.search = urlParams;
    }

    function cleanReload(callback){
        let url = window.location.origin + window.location.pathname + window.location.hash;
        document.location.href = url;
        callback();
    }

    function hideFormShowAdresses(){
        jQuery('.form-wrapper').addClass('hide-dom');
        jQuery('.saved-addresses').removeClass('hide-dom');
    }

    function setSelectValue(select_id, new_value){
        let sortBySelect = document.getElementById(select_id);
			sortBySelect.value = new_value;
			sortBySelect.dispatchEvent(new Event("change"));
    }

    //Установка сохраненной страны/провинции
    function setDefaultProvince(selector){
        var defaultCountry = jQuery('body').find(selector).data('default');
        var selectId = jQuery('body').find(selector).attr('id');
        if(typeof defaultCountry !== "undefined" && defaultCountry !== "" && defaultCountry !== false){
            setSelectValue(selectId, defaultCountry);
        }
    }

    //Установка провинций определенной страны
    function setProvinces(countrySelector, provincesSelector, defaultProvince=false){
        var raw = jQuery('body').find(countrySelector).find(':selected').data('provinces');
        var provinces = raw;
        if (provinces && provinces.length == 0) {
            jQuery('body').find(provincesSelector).parent().parent().addClass('hide-dom');
        } else {
            jQuery('body').find(provincesSelector).html('');
            for (var i = 0; i < provinces.length; i++) {
              var opt = document.createElement('option');
              opt.value = provinces[i][0];
              opt.innerHTML = provinces[i][1];
              jQuery(provincesSelector).append(opt);
            }
            if(defaultProvince){
                setDefaultProvince(provincesSelector);
            }
            jQuery('body').find(provincesSelector).parent().parent().removeClass('hide-dom');
          }
    }

    /* Создать куку */
    function createCookie(name, value, days) {
        if (days) {
          var date = new Date();
          date.setTime(date.getTime()+(days*24*60*60*1000));
          var expires = "; expires="+date.toGMTString();
        }
        else var expires = "";
        document.cookie = name+"="+value+expires+"; path=/";
    }

    /* получить куку */
    function getCookie(name) {
        let matches = document.cookie.match(new RegExp(
            "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
        ));
        return matches ? decodeURIComponent(matches[1]) : undefined;
    }

    jQuery('img.svg').each(function () {
        imgToSvgConvert(jQuery(this));
    });

    /*Закритие корзини*/
    jQuery('body').on('click', '.close-form-cart-btn', function(e){
        console.log('close-form-cart-btn');
        e.stopPropagation();
        hideLoader();
        jQuery(this).closest('.form-popup').removeClass('open');
        jQuery('.inner-div').removeClass('slide-left');
        jQuery('body').removeClass('no-scroll');
        createCookie('nl-popup-opened', 1, 1);
    });
    /*Закритие корзини при жмаке мимо*/
    jQuery('body').on('click', '.inner-div', function(){
        if (jQuery('.inner-div').hasClass('slide-left')) {
           console.log('inner-div click');
           jQuery('.close-form-cart-btn').trigger('click');
           jQuery('.close-form-size-guide-btn').trigger('click');
        }
    });
    /*Закритие Size Guide*/
    jQuery('body').on('click', '.close-form-size-guide-btn', function(e){
        e.stopPropagation();
        jQuery(this).closest('.form-popup').removeClass('open');
        jQuery('.inner-div').removeClass('slide-left');
        jQuery('body').removeClass('no-scroll');
    });

    /*Кнопка для вызова форм PopUp*/
    if (jQuery('.btn-call').length) {

        jQuery('.btn-call').on('click', function () {
            console.dir(`jQuery('.btn-call').on('click', function () {`);
            //var height = $('.formCall').outerHeight();
            //var top = ($(window).height() - height) / 2 - 60;

            var top = window.pageYOffset || document.documentElement.scrollTop;
            var formName = jQuery(this).data('target');
            var width = jQuery('.' + formName).outerWidth();
            //var width = jQuery('.form-popup').outerWidth();
            var left = (jQuery(window).width() - width) / 2;

            if (formName == 'form-cart' || formName == 'form-size-guide' || formName == 'form-final-sale') {

                jQuery('.' + formName).css("right", 0 + "px");
                if (formName == 'form-cart') {
                    console.dir(`if (formName == 'form-cart') {`);
                    jQuery('.' + formName).css("top", 0 + "px");
                }
                if (formName == 'form-size-guide') {
                    jQuery('.' + formName).css("top", top + "px");
                    jQuery('.form-size-guide .size-guide-slider').slick("refresh");
                }
                if (formName == 'form-final-sale') {
                    jQuery('.' + formName).css("top", top + "px");
                    jQuery('.form-final-sale .size-guide-slider').slick("refresh");
                }
            } else {
                jQuery('.' + formName).css("top", top + 40 + "px");
                jQuery('.' + formName).css("left", left + "px");
            }

            jQuery('.inner-div').addClass('blur');
            jQuery('.bg-gray-popup').fadeIn(400);
            jQuery('.' + formName).fadeIn(400);

        });

        jQuery('body').on('click', '.close-form-btn', function(){
            hideLoader();
            jQuery('.bg-gray-popup').fadeOut(400);
            jQuery(this).closest('.form-popup').fadeOut(400);
            jQuery('.inner-div').removeClass('blur');
            createCookie('nl-popup-opened', 1, 1);
        });

        /* Вызываем попап newsletter при скролле страницы */
        jQuery(window).scroll(function() {
            var top = window.pageYOffset || document.documentElement.scrollTop;
            var formName = 'form-newsletter';
            let opened = getCookie('nl-popup-opened');
            var width = jQuery('.' + formName).outerWidth();
            //var width = jQuery('.form-popup').outerWidth();
            var left = (jQuery(window).width() - width) / 2;
            if (formName == 'form-newsletter' && opened != 1) {
                jQuery('.' + formName).css("top", top + 40 + "px");
                jQuery('.' + formName).css("left", left + "px");

                jQuery('.inner-div').addClass('blur');
                jQuery('.bg-gray-popup').fadeIn(400);
                jQuery('.' + formName).fadeIn(400);
            }
        });
        /* Вызываем попап newsletter при скролле страницы END */
    }

    /*Закрытие форм, если нажать на серый фон, т.е мимо формы*/
    if (jQuery('.bg-gray-popup').length) {
        jQuery('.bg-gray-popup').on('click', function () {
            hideLoader();
            jQuery('.bg-gray-popup').fadeOut(400);
            jQuery('.form-popup').fadeOut(400);
            jQuery('.inner-div').removeClass('blur');
            createCookie('nl-popup-opened', 1, 1);
        });
    }

     /*Открытие Size Guide*/
     jQuery('.btn-call-size-guide').on('click', function (e) {
        e.stopPropagation();
        jQuery('.form-size-guide').addClass('open');
        jQuery('.inner-div').addClass('slide-left');
        jQuery('body').addClass('no-scroll');
     });

     /* Final sale popup right open */
     
     jQuery('.btn-call-final-sale').on('click', function (e) {
        e.stopPropagation();
        jQuery('.final-sale-popup').addClass('open');
        jQuery('body').addClass('no-scroll');
     });

     jQuery('.final-sale-popup__close-btn').on('click', function (e) {
        e.stopPropagation();
        jQuery('.final-sale-popup').removeClass('open');
        jQuery('body').removeClass('no-scroll');
     });

     jQuery('.final-sale-popup__bg').on('click', function (e) {
        e.stopPropagation();
        jQuery('.final-sale-popup').removeClass('open');
        jQuery('body').removeClass('no-scroll');
     });

     /* Final sale popup right open END */

    /*Увеличение и уменьшение числа товаров в корзине, минимальное число товаров 0*/
    jQuery('body').on('click', '.search-activator', function (event) {
        jQuery(this).closest('.main-menu-mobile').find('form.search-form').attr("style", "display: block !important").show().find("[type='text']").focus();
      console.log('search click')
    });

    /*Закрытие формы поиска*/
    jQuery('form.search-form .close-form-btn').on('click', function () {
        jQuery('form.search-form').fadeOut(200);
        jQuery('.search-form-results').fadeOut(200);

        jQuery('.main-menu-mobile').removeClass('open-search-form');
    });

    /*Открытие результатов поиска*/
    jQuery('form.search-form .btn-search[type="submit"]').on('click', function (e) {
        e.preventDefault();
        //Live Search
        jQuery('.loader-search').removeClass('hide');
        let search_value = jQuery('#Search').val();
        let url = window.location.origin + '/search' + '?q=' +search_value;
        let selectorId = 'search-form-results';
        //renderSectionFromFetchById
        var finalCallback = () => {
            jQuery('.search-form-results').show();
            jQuery('.loader-search').addClass('hide');

            jQuery('.main-menu-mobile').addClass('open-search-form');
            // jQuery('.main-menu-mobile .close-form-btn').css('display', 'block');
            // jQuery('.main-menu-mobile .btn-search').css('display', 'none');

        }
        renderSectionFromFetchById(url, selectorId, finalCallback, liveUpdateBlockById);
    });

    /*Переключение вкладок на странице поиска*/
    jQuery('.section-search-top .btn-wrapper .btn').on('click', function (e) {
        jQuery(this).closest('.btn-wrapper').find('.btn').removeClass('active');
        jQuery(this).addClass('active');
        var formName = jQuery(this).data('target');
        if (formName == 'section-collection') {
            jQuery('.section-search').hide();
            jQuery('.' + formName).show();
        }
        if (formName == 'section-journal-search') {
            jQuery('.section-search').hide();
            jQuery('.' + formName).show();
        }
    });

    /*Увеличение и уменьшение числа товаров в корзине, минимальное число товаров 0*/
    jQuery('body').on('click', '.quantity-block .minus', function (event) {
        var obj = jQuery(this).closest('.quantity-block').find('.product-cnt');
        var val = obj.val();
        console.dir(`minus val`);console.dir(val);

        let variant_id = jQuery(this).parent().parent().parent().data('variant-id');
        console.dir(`variant_id`);console.dir(variant_id);
        removeItemFromCart(variant_id, val);

        if (val > 0) {
            obj.val(--val)
        }

        obj.trigger("change");
    });

    jQuery('body').on('click', '.quantity-block .plus', function (event) {
        var obj = jQuery(this).closest('.quantity-block').find('.product-cnt');
        var val = obj.val();
        console.dir(`plus val`);console.dir(val);

        let variant_id = jQuery(this).parent().parent().parent().data('variant-id');
        console.dir(`variant_id`);console.dir(variant_id);
        addItemToCart(variant_id, 1, addToCartPost);

        obj.val(++val);
        obj.trigger("change");
    });

    jQuery('body').on('click', '.cart-item .trash', function (event) {
        let variant_id = jQuery(this).parent().parent().data('variant-id');
        console.dir(`variant_id`);console.dir(variant_id);
        removeItemFromCart(variant_id, 0);
    });

    /* Переключалка цветов товара */
    jQuery('.color-list > li, .amount-list > li').on('click', function () {
        jQuery(this).closest('.color-list, .amount-list').find('li').removeClass('active');
        jQuery(this).addClass('active');
    });

    /* Переключалка списка размеров в Size Guide Modal */
    jQuery('body').on('click', '.size-list > li', function(){
        jQuery(this).closest('.size-list').find('li').removeClass('active');
        jQuery(this).addClass('active');
        let className = jQuery(this).data('selector');
        let selector = '.'+className;
        let index = 0;
        index = jQuery(selector).first().data('index');
        jQuery('.size-guide-slider').slick('slickUnfilter');
        jQuery('.size-guide-slider').slick('slickFilter', selector);
    });


    /* При наведении на елемент товара, показать список размеров */
    jQuery('body').on('mouseenter', '.product-row .item .img-wrapper', function(){
        var size_list = jQuery(this).find('.size-list');

        if(size_list.length > 0){
            jQuery(this).find('.add-to-cart').removeClass('add-to-cart-hide');
            jQuery(this).find('.add-to-cart-style').removeClass('add-to-cart-hide');
        } else {
            jQuery(this).find('.add-to-cart').removeClass('add-to-cart-hide');
            jQuery(this).find('.add-to-cart-style').removeClass('add-to-cart-hide');
        }

    });
    /* При отведении, спрятать список размеров и add-to-cart */
    jQuery('body').on('mouseleave', '.product-row .item .img-wrapper', function(){
        jQuery(this).find('.size-list').addClass('size-list-hide');
        jQuery(this).find('.add-to-cart').addClass('add-to-cart-hide');
        jQuery(this).find('.add-to-cart-style').addClass('add-to-cart-hide');
    });

    /* QUICK ADD btn Click */
    jQuery('body').on('click', '.item .add-to-cart-style', function(){
        if(jQuery(this)[0].hasAttribute('data-href')){
            console.dir(`if(jQuery(this).hasAttribute('data-href')){`);
            let href = jQuery(this).attr('data-href');
            console.dir(`href`);console.dir(href);
            window.location.href = href;
            return;
        }
    });

    jQuery('body').on('click', '.item .add-to-cart', function(){
        console.log(`%c jQuery('body').on('click', '.item .add-to-cart', function(){`, `color: red; font-weight:bold; background-color: yellow;`);

        if(jQuery(this)[0].hasAttribute('data-href')){
            console.dir(`if(jQuery(this).hasAttribute('data-href')){`);
            let href = jQuery(this).attr('data-href');
            console.dir(`href`);console.dir(href);
            window.location.href = href;
            return;
        }

        let is_sizes = jQuery(this).attr('data-is-sizes');
        if(is_sizes == "false" || is_sizes == false){
            let variant_id = jQuery(this).attr('data-first-variant-id');

            let pre_order = jQuery(this).data('pre-order');
            let properties = new Object();
            if(pre_order == true || pre_order == 'true'){
                let pre_order_msg_1 = jQuery(this).data('pre-order-msg-1');
                if(pre_order_msg_1 != ' ' && pre_order_msg_1 != 'false' && pre_order_msg_1 != false && pre_order_msg_1 != undefined && pre_order_msg_1.toString().length > 0){
                    properties[pre_order_msg_1] = " ";
                }
            }
            addFinalSaleProperty(this, properties);

            let variantObj = new Object();
            variantObj['id'] = variant_id;
            variantObj['quantity'] = 1;
            if(!isObjectEmpty(properties)){
                variantObj['properties'] = properties;
            }
            let variantsArr = [];
            variantsArr.push(variantObj);
            addMultiItemsToCart(variantsArr, addToCartPost);

            // addItemToCart(variant_id, 1, addToCartPost);
        } else {
            jQuery(this).closest('.img-wrapper').find('.size-list').removeClass('size-list-hide');
            jQuery(this).closest('.img-wrapper').find('.add-to-cart').addClass('add-to-cart-hide');
        }
    });

    /* Переключалка списка размеров в Size Guide Product і в колекції */
    jQuery('body').on('click', '.product-row .item .size-list > li', function(){
        var variant_id = jQuery(this).data('variant-id');
        let pre_order = jQuery(this).data('pre-order');
        let properties = new Object();
        if(pre_order == true || pre_order == 'true'){
            let pre_order_msg_1 = jQuery(this).data('pre-order-msg-1');
            if(pre_order_msg_1 != ' ' && pre_order_msg_1 != 'false' && pre_order_msg_1 != false && pre_order_msg_1 != undefined && pre_order_msg_1.toString().length > 0){
                properties[pre_order_msg_1] = " ";
            }
        }
        addFinalSaleProperty(this, properties);

        let variantObj = new Object();
        variantObj['id'] = variant_id;
        variantObj['quantity'] = 1;
        if(!isObjectEmpty(properties)){
            variantObj['properties'] = properties;
        }
        let variantsArr = [];
        variantsArr.push(variantObj);
        addMultiItemsToCart(variantsArr, addToCartPost);

        // addItemToCart(variant_id, 1, addToCartPost);
    });

    /*Переключалка списка в сайдбаре*/
    jQuery('.sidebar-list li').on('click', function () {
        jQuery(this).closest('.sidebar-list').find('li').removeClass('active');
        jQuery(this).addClass('active');
        let index = 0;
        index = jQuery(this).index();
        jQuery(this).closest('.container').find('.content-wrapper .order-tab').removeClass('active');
        jQuery(this).closest('.container').find('.content-wrapper .order-tab:eq('+index+')').addClass('active');
        jQuery('.sidebar-list-select').val(jQuery('.sidebar-list-select option:eq('+index+')').val());
    });

    /*Список для перехода на мобилке*/
    jQuery('.sidebar-list-select').val(jQuery('.sidebar-list-select option:first').val());
    jQuery('.sidebar-list-select').on('change', function() {
        let index = this.value;
        let hash = jQuery(this).find('option:selected').data('hash');
        console.dir(`hash`);console.dir(hash);
        jQuery('.sidebar-list li:eq('+index+')').trigger('click');

        document.location.hash = hash;
    });

    //Переключалка в аккаунте
    if(window.location.pathname == '/account'){
        if(window.location.hash == '#saved-addresses'){
            var this_obj = jQuery('.sidebar-list li a[href="'+window.location.hash+'"]').parent();
            jQuery(this_obj).closest('.sidebar-list').find('li').removeClass('active');
            jQuery(this_obj).addClass('active');
            let index = 0;
            index = jQuery(this_obj).index();
            jQuery(this_obj).closest('.container').find('.content-wrapper .order-tab').removeClass('active');
            jQuery(this_obj).closest('.container').find('.content-wrapper .order-tab:eq('+index+')').addClass('active');
            jQuery('.sidebar-list-select').val(jQuery('.sidebar-list-select option:eq('+index+')').val());
        } else if(window.location.hash == '#order-history') {

        } else {
            document.location.hash = '#order-history';
        }

        setProvinces('#AddressCountryNew', '#AddressProvinceNew', false);
        jQuery('body').on('click', '.add-address', function(){
            setProvinces('#AddressCountryNew', '#AddressProvinceNew', false);
        });
        // jQuery('#AddressCountryNew').on('change', function () {
        jQuery('body').on('change', '#AddressCountryNew', function(){
            setProvinces('#AddressCountryNew', '#AddressProvinceNew', false);
        });

        jQuery('body').on('click', '.btn-edit-address', function(){
            var form_id = jQuery(this).data('form-id');
            var countrySelector = '#'+form_id+' .address-country';
            var provincesSelector = '#'+form_id+' .address-province';
            setDefaultProvince(countrySelector);
            setProvinces(countrySelector, provincesSelector, true);

            // jQuery(countrySelector).on('change', function () {
            jQuery('body').on('change', countrySelector, function(){
                setProvinces(countrySelector, provincesSelector, false);
            });

            jQuery('.order-tab .saved-addresses').addClass('hide-dom');
            jQuery('#'+form_id).removeClass('hide-dom');
        });

        jQuery('body').on('click', '.cancel', function(){
            event.preventDefault();
            jQuery('.form-wrapper').addClass('hide-dom');
            jQuery('.saved-addresses').removeClass('hide-dom');
        });
    }

    /*Переключалка списка в сайдбаре FAQ*/
    jQuery('.accordion-list li').on('click', function () {
        jQuery(this).closest('.accordion-list').find('li').removeClass('active');
        jQuery(this).addClass('active');
        let index = 0;
        index = jQuery(this).index();
        if (index) {
            let destination = jQuery('#accordionExample'+index).offset().top;
            if (destination) {
                jQuery('html, body').animate({scrollTop: destination}, 500, "swing");
            }
        }
        jQuery('.accordion-select').val(jQuery('.accordion-select option:eq('+index+')').val());
    });

    /*Список для перехода к подразделу*/
    jQuery('.accordion-select').val(jQuery('.accordion-select option:first').val());
    jQuery('.accordion-select').on('change', function() {
        let index = this.value;
        jQuery('.accordion-list li:eq('+index+')').trigger('click');
    });

    /*Показать форму добавления адреса*/
    jQuery('body').on('click', '.saved-addresses .add-address', function(){
        console.dir(`.saved-addresses .add-address click`);

        jQuery('.order-tab .saved-addresses').addClass('hide-dom');
        jQuery('.add-addresses').removeClass('hide-dom');
        
        // jQuery('.order-tab .saved-addresses').hide();
        // jQuery('.add-addresses').show();

    });

    /*Скрить форму добавления адреса*/
    jQuery('body').on('click', '.add-addresses .cancel', function(){
        jQuery('.add-addresses').addClass('hide-dom');
        jQuery('.saved-addresses').removeClass('hide-dom');

        // jQuery('.add-addresses').hide();
        // jQuery('.saved-addresses').show();
    });

    /*Datepicker*/
    jQuery('.datepicker').datepicker({
        // format: 'dd.mm.yyyy',
        format: 'yyyy-mm-dd',
        startDate: '-3d'
    });


    /*Бегущая строка header top*/
    if (jQuery('.ticker-slider').length) {
        let width = jQuery(window).width();
            width = parseInt(width);
        jQuery('.ticker-slider').slick({
            arrows: false, /*Стрелки навигации*/
            dots: false, /*Точки навигации*/
            autoplay: false, /*Автопрокрутка*/
            infinite: true,
            variableWidth: true,
            autoplaySpeed: 0, /*Интервал смены слайдов*/
            speed: 1000, /*Скорость анимации*/
            lazyLoad: 'progressive', /*Ленивая загрузка 'ondemand' or 'progressive'*/
            waitForAnimate: true, /*Ждать окончания анимации*/
            slidesToShow: 4,
            slidesToScroll: 1,
            touchMove: true, // Enable slide motion with touch
            touchThreshold: width, // To advance slides, the user must swipe a length of (1/touchThreshold) * the width of the slider
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        });
    }

        /*Слайдер продуктов*/
    if (jQuery('.product-slider').length) {
        const setImageRenederWidth = (callback) => {
                let renderWidth = jQuery('.product-slider .item:first-child .img-wrapper a img').width();

                console.dir(`renderWidth`);console.dir(renderWidth);
                renderWidth = renderWidth * 0.7;
                console.dir(`renderWidth`);console.dir(renderWidth);

                let renderWidthStr = renderWidth+'px';
                if(renderWidth>100){
                    jQuery('.product-slider .item .img-wrapper a img').css({
                        'width': renderWidthStr
                    });
                    jQuery('.product-slider .item .img-wrapper').css({
                        'width': renderWidthStr
                    });
                    jQuery('.product-slider .item').css({
                        'width': renderWidthStr
                    });
                }
                callback();
            };
        const renderProductSlider = () => {
                    jQuery('.product-slider').slick({
                        arrows: true, /*Стрелки навигации*/
                        dots: false, /*Точки навигации*/
                        autoplay: false, /*Автопрокрутка*/
                        infinite: true,
                        variableWidth: false,
                        autoplaySpeed: 0, /*Интервал смены слайдов*/
                        speed: 1000, /*Скорость анимации*/
                        lazyLoad: 'progressive', /*Ленивая загрузка 'ondemand' or 'progressive'*/
                        waitForAnimate: true, /*Ждать окончания анимации*/
                        slidesToShow: 4,
                        slidesToScroll: 1,
                        responsive: [
                            {
                                breakpoint: 1200,
                                settings: {
                                    slidesToShow: 3
                                }
                            },
                            {
                                breakpoint: 768,
                                settings: {
                                        slidesToShow: 2
                                }
                            },
                            {
                                breakpoint: 576,
                                settings: {
                                    slidesToShow: 1,
                                    slidesToScroll: 1,
                                    centerMode: true,
                                    variableWidth: true
                                }
                            }
                        ]
                    });
            };
            if (document.documentElement.clientWidth < 576) {
                setImageRenederWidth(renderProductSlider);
            }
            else {
                renderProductSlider();
            }
    }



    /* Announcement Slider */
    // if(jQuery('.announcement-slider').length) {
    //     let data_autoplay = jQuery('.announcement-slider').attr('data-autoplay');
    //     let delay = false;
    //     if(data_autoplay == 'true'){
    //         delay = +jQuery('.announcement-slider').attr('data-delay');
    //     }

    //     jQuery('.announcement-slider').flickity({
    //         pageDots:false,
    //         autoPlay:delay,
    //         pauseAutoPlayOnHover:true,
    //             on: {
    //                 ready: function() {
    //                     setHeaderBreadcrumbsPosition();
    //             }
    //         }
    //     });
    // }
    /* Announcement Slider END */

    /* Collection cross link slider */
    if(jQuery('.crosslink-carousel').length) {
        window.carousel = jQuery('.crosslink-carousel').flickity({
            freeScroll: false,
            cellAlign:'left',
            contain: true,
            wrapAround:false,
            draggable: true,
            pageDots:false,
            groupCells: '100%'
        });

        if(jQuery('.crosslink__active').length > 0) {
            let index = +jQuery('.crosslink__active').attr('data-index');
            window.carousel.flickity('selectCell', index, true, true);
        }
    }
    /* Collection cross link slider END */

    /* New products carusel */
    if(jQuery('.new-carusel__slider').length) {
        $('.new-carusel__slider').flickity({
            freeScroll:false,
            cellAlign:'left',
            contain:true,
            wrapAround:true,
            draggable:true,
            pageDots:false,
            groupCells:'100%',
            on: {
                ready: function() {
                    let product_card_labels = document.querySelectorAll('.product-card-labels');
                    product_card_labels.forEach((element) => {
                        element.removeAttribute('style');
                    });
                },
                change: function( index ) {
                    let product_card_labels = document.querySelectorAll('.product-card-labels');
                    product_card_labels.forEach((element) => {
                        element.removeAttribute('style');
                    });
                }
            }
        });
    }
    /* New products carusel END */

    /* Product card slider */
    if(jQuery('.product-card-slider').length) {
        if (document.documentElement.clientWidth < 821) {
            jQuery('.product-card-slider').each(function () {
                let $carousel = jQuery(this);

                let createCarusel = () => {
                    let $scrollBarContainer = $carousel.parent().find('.scroll-bar-container');
                    let $scrollBar = $scrollBarContainer.find('.flickity-scroll-bar');
                    $carousel.flickity({
                        pageDots:false,
                        prevNextButtons:false,
                        draggable: true,
                        on: {
                            ready: function() {
                                updateScrollBarWidth($carousel);
                            },
                            change: function( index ) {
                                    $carousel.find('.product__image').each(function (i) {
                                        // if(index === i){
                                            let $image = jQuery(this);
                                            if($image.attr('src') === '' && $image.attr('data-custom-lazyload')){
                                                $image.attr('src', $image.attr('data-custom-lazyload'));
                                            }
                                        // }
                                    });
                            }
                        }
                    });

                    let scrollEndTimer;
                    $carousel.on('scroll.flickity', function (event, progress) {
                        progress = Math.max(0, Math.min(1, progress));
                        let scrollWidth = updateScrollBarWidth($carousel);
                        let progressPrecent;

                        if(progress >= 1){
                            progressPrecent = (progress * 100) - scrollWidth;
                        } else {
                            progressPrecent = (progress * 100) - scrollWidth;
                        }

                        $scrollBar.css('opacity', 0.5);
                        $scrollBar.css('left', progressPrecent + '%');

                        clearTimeout(scrollEndTimer);
                        scrollEndTimer = setTimeout(function () {
                            $scrollBar.stop().animate({ opacity: 0 }, 500);
                        }, 200);
                    });
                
                    function updateScrollBarWidth($carousel) {
                        let slideCount = $carousel.find('.product__image').length;
                        let scrollWidth = 100 / slideCount;
                        $scrollBar.width(scrollWidth + '%');
                        return scrollWidth;
                    }
                }

                let firstImage = $carousel.find('.product__image').first();
                let isLazyLoad = firstImage.attr('data-set-lazy-load');
                if(isLazyLoad == true || isLazyLoad == 'true'){
                    if (!firstImage.hasClass('lazyloaded')) {
                        firstImage.on('load', function() {
                            createCarusel();
                        });
                    } else {
                        createCarusel();
                    }
                } else {
                    createCarusel();
                }

            });
        }
    }

    /* Product card slider end */

    /* Home logos-text slider */

    if(jQuery('.logos-text__slider').length) {
        jQuery('.logos-text__slider').slick({
            arrows: false,
            dots: false,
            adaptiveHeight: true,
            asNavFor: '.logos-images__slider'
        });
    }

    if(jQuery('.logos-images__slider').length) {
        jQuery('.logos-images__slider').slick({
            slidesToShow: 5,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            centerMode: true,
            focusOnSelect: true,
            variableWidth: false,
            asNavFor: '.logos-text__slider',
            responsive: [
                {
                    breakpoint: 1096,
                    settings: {
                        slidesToShow: 4
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                            slidesToShow: 3
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                            slidesToShow: 3
                    }
                },
                {
                    breakpoint: 740,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 540,
                    settings: {
                        slidesToShow: 1,
                        centerPadding:'110px'
                    }
                },
                {
                    breakpoint: 500,
                    settings: {
                        slidesToShow: 1,
                        centerPadding:'90px'
                    }
                },
                {
                    breakpoint: 419,
                    settings: {
                        slidesToShow: 1,
                        centerPadding:'80px'
                    }
                },
                {
                    breakpoint: 380,
                    settings: {
                        slidesToShow: 1,
                        centerPadding:'70px'
                    }
                },
                {
                    breakpoint: 350,
                    settings: {
                        slidesToShow: 1,
                        centerPadding:'60px'
                    }
                },
                {
                    breakpoint: 320,
                    settings: {
                        slidesToShow: 1,
                        centerPadding:'50px'
                    }
                },
                {
                    breakpoint: 280,
                    settings: {
                        slidesToShow: 1,
                        centerPadding:'40px'
                    }
                }
            ]
        });
    }

    /* Home logos-text slider END. */

    /* Reviews Slider */
    if(jQuery('.reviews-slider').length) {
        jQuery('.reviews-slider').slick({
            centerMode: true,
            arrows: true, /*Стрелки навигации*/
            dots: false, /*Точки навигации*/
            autoplay: false, /*Автопрокрутка*/
            infinite: true,
            variableWidth: false,
            autoplaySpeed: 0, /*Интервал смены слайдов*/
            speed: 1000, /*Скорость анимации*/
            lazyLoad: 'progressive', /*Ленивая загрузка 'ondemand' or 'progressive'*/
            waitForAnimate: true, /*Ждать окончания анимации*/
            slidesToShow: 3,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 1096,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                            slidesToShow: 1
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 1
                    }
                },
                {
                    breakpoint: 419,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        centerMode: false,
                        svariableWidth: true
                    }
                }
            ]
        });
    }
    /* Reviews Slider END */

    /* Bestsellers Landing */
    if (jQuery('.best-seller-landing').length) {
        jQuery('body').on('click', '.bs-landing__thumb', function(){
            let bigImgSrc = jQuery(this).data('big-img');
            let url = jQuery(this).data('url');
            jQuery('.bs-landing__big-image').attr('src', bigImgSrc);
            jQuery('.bs-landing__btn').attr('href', url);
        });
    }
    /* Bestsellers Landing END */
        
    /*Слайдер продуктов*/
    if (jQuery('.size-guide-slider').length) {
        jQuery('.size-guide-slider').slick({
            arrows: true, /*Стрелки навигации*/
            dots: false, /*Точки навигации*/
            autoplay: false, /*Автопрокрутка*/
            infinite: false,
            variableWidth: false,
            autoplaySpeed: 0, /*Интервал смены слайдов*/
            speed: 1000, /*Скорость анимации*/
            lazyLoad: 'progressive', /*Ленивая загрузка 'ondemand' or 'progressive'*/
            waitForAnimate: true, /*Ждать окончания анимации*/
            slidesToShow: 3,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        });
    }

    /*Слайдер фото*/
    if (jQuery('.photo-slider').length) {
        jQuery('.photo-slider').slick({
            arrows: false, /*Стрелки навигации*/
            dots: false, /*Точки навигации*/
            autoplay: false, /*Автопрокрутка*/
            infinite: true,
            variableWidth: false,
            autoplaySpeed: 0, /*Интервал смены слайдов*/
            speed: 1000, /*Скорость анимации*/
            lazyLoad: 'progressive', /*Ленивая загрузка 'ondemand' or 'progressive'*/
            waitForAnimate: true, /*Ждать окончания анимации*/
            slidesToShow: 4,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        slidesToShow: 2
                    }
                }
            ]
        });
    }

    /*Слайдер категорий в хедере mobile*/
    /*
    if (jQuery(window).width() < 768) {
        if (jQuery('.section-shop-category-sm').length) {
            let width = jQuery(window).width();
                width = parseInt(width);
            jQuery('.section-shop-category-sm').slick({
                arrows: false, //Стрелки навигации
                dots: false, //Точки навигации
                autoplay: false, //Автопрокрутка
                infinite: false,
                variableWidth: false,
                lazyLoad: 'progressive', //Ленивая загрузка 'ondemand' or 'progressive'
                autoplaySpeed: 0, //Интервал смены слайдов
                speed: 1000, //Скорость анимации
                waitForAnimate: false, // Ждать окончания анимации
                slidesToShow: 5,
                slidesToScroll: 1,
                touchMove: true, // Enable slide motion with touch
                touchThreshold: width, // To advance slides, the user must swipe a length of (1/touchThreshold) * the width of the slider
                responsive: [
                    {
                        breakpoint: 576,
                        settings: {
                            slidesToShow: 4
                        }
                    }
                ]
            });
        }
    }
    */

    /*Слайдер спонсоров на главной about us mobile*/
    // if (jQuery(window).width() < 992) {
    //     if (jQuery('.sponsor-slider').length) {
    //         jQuery('.sponsor-slider').slick({
    //             arrows: false, /*Стрелки навигации*/
    //             dots: false, /*Точки навигации*/
    //             autoplay: false, /*Автопрокрутка*/
    //             infinite: false,
    //             variableWidth: false,
    //             autoplaySpeed: 0, /*Интервал смены слайдов*/
    //             speed: 1000, /*Скорость анимации*/
    //             lazyLoad: 'progressive', /*Ленивая загрузка 'ondemand' or 'progressive'*/
    //             waitForAnimate: true, /*Ждать окончания анимации*/
    //             slidesToShow: 4,
    //             slidesToScroll: 1,
    //             responsive: [
    //                 {
    //                     breakpoint: 768,
    //                     settings: {
    //                         slidesToShow: 3
    //                     }
    //                 },
    //                 {
    //                     breakpoint: 576,
    //                     settings: {
    //                         slidesToShow: 2
    //                     }
    //                 }
    //             ]
    //         });
    //     }
    // }


    /*Слайдер на главной Molly’s Journal mobile*/
    if (jQuery(window).width() < 768) {
        if (jQuery('.section-journal .journal-row, .section-related-articles .journal-row').length) {
            jQuery('.section-journal .journal-row, .section-related-articles .journal-row').slick({
                arrows: false, /*Стрелки навигации*/
                dots: false, /*Точки навигации*/
                autoplay: false, /*Автопрокрутка*/
                infinite: false,
                variableWidth: false,
                autoplaySpeed: 0, /*Интервал смены слайдов*/
                speed: 1000, /*Скорость анимации*/
                lazyLoad: 'progressive', /*Ленивая загрузка 'ondemand' or 'progressive'*/
                waitForAnimate: true, /*Ждать окончания анимации*/
                slidesToShow: 2,
                slidesToScroll: 1,
                responsive: [
                    {
                        breakpoint: 576,
                        settings: {
                            slidesToShow: 1
                        }
                    }
                ]
            });
        }
    }

    /*Слайдер на странице Сингла продукта*/
    if (jQuery(window).width() < 992) {
        if (jQuery('.gallery-slider').length) {
            jQuery('.gallery-slider').slick({
                arrows: true, /*Стрелки навигации*/
                dots: false, /*Точки навигации*/
                autoplay: false, /*Автопрокрутка*/
                infinite: true,
                variableWidth: false,
                autoplaySpeed: 0, /*Интервал смены слайдов*/
                speed: 1000, /*Скорость анимации*/
                lazyLoad: 'progressive', /*Ленивая загрузка 'ondemand' or 'progressive'*/
                waitForAnimate: true, /*Ждать окончания анимации*/
                slidesToShow: 1,
                slidesToScroll: 1,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 2
                        }
                    },
                    {
                        breakpoint: 576,
                        settings: {
                            slidesToShow: 1
                        }
                    }
                ]
            });
        }
    }

    /*Прокрутка вверх*/
    jQuery('.to-top').on('click', function () {
      	console.dir('To top!');
        let destination = jQuery('.inner-div').offset().top;
        jQuery('html, body').animate({scrollTop: destination}, 1100, "swing");
    });


    jQuery('body').on('change', '.filter-select', function(){
        var value = jQuery(this).val();
        let newClass = value;
            newClass = newClass.toLowerCase();
        jQuery(this).removeClass('clear xxxs clear xxs xxl xxxl xs xl s m l');
        jQuery(this).addClass(newClass);
        jQuery(this).find( "option:selected" ).each(function() {
            var filter = jQuery(this).attr('name');
            updateUrl(filter, value);
        });
    });

    jQuery('body').on('change', '#sortBy', function(){
        var filter = jQuery(this).attr('name');
        jQuery(this).find( "option:selected" ).each(function() {
            var value = jQuery(this).val();
            let newClass = value;
            jQuery(this).parent().removeClass('manual best-selling title-ascending title-descending price-ascending price-descending created-ascending created-descending');
            jQuery(this).parent().addClass(newClass);
            updateUrl(filter, value);
        });
    });
    
    //Product page
    //Update price by size select
    jQuery('body').on('change', '#product-size', function(){
        jQuery(this).find( "option:selected" ).each(function() {
            var price = jQuery(this).data('price');
            var compare_at_price = jQuery(this).data('compare_at_price');
            var title = jQuery(this).data('title');
            jQuery('.add-to-cart .price').text(price);
            jQuery('.add-to-cart .price-old').text(compare_at_price);
            jQuery('.section-sticky .variant-title').text(title);
        });
    });

    jQuery('body').on('change', '#checkIncludeCart', function(){
        console.dir(`jQuery('body').on('change', '#checkIncludeCart', function(){`);
        let variant_id = jQuery(this).data('variant_id');
        console.dir(`variant_id`);console.dir(variant_id);
        let variantsArr = [
            {
                "id": variant_id,
                "quantity": 1
            }
        ];
        addMultiItemsToCart(variantsArr, addToCartPost);
    });

    function isObjectEmpty(obj) {
        return Object.keys(obj).length === 0;
    }

    // Final sale: mark the cart line so the label shows in checkout and the order email.
    // Nearest wrapper wins, so a regular product card inside a final sale product page is not marked.
    function addFinalSaleProperty(el, properties) {
        if(jQuery(el).closest('[data-final-sale]').attr('data-final-sale') == 'true'){
            properties['Final Sale'] = "Yes";
        }
    }

    //Add to cart product from product page
    jQuery('.form-group .add-to-cart, .sticky-to-cart .add-to-cart').on('click', function () {
        event.preventDefault();
        console.log(`%c ### Add to cart product page Click! ###`, `color: red; font-weight:bold; background-color: yellow;`);

        let product_id = jQuery(this).data('product-id');
        console.dir(`product_id`);console.dir(product_id);

        let pre_order = jQuery(this).data('pre-order');
        console.dir(`pre_order`);console.dir(pre_order);

        let pre_order_msg_1 = jQuery(this).data('pre-order-msg-1');

        let variant_id = product_id;
        if(jQuery('#sizes-select-popup .sizes-select-popup-list li.selected').first().length > 0){
            let selectedVariant = jQuery('#sizes-select-popup .sizes-select-popup-list li.selected').first();
            variant_id = selectedVariant.data('variant-id');
            console.dir(`variant_id`);console.dir(variant_id);

            pre_order = selectedVariant.data('pre-order');
            pre_order_msg_1 = selectedVariant.data('pre-order-msg-1');
        }
        if(jQuery('#product-amount li.active').first().length > 0){
            variant_id = jQuery('#product-amount li.active').first().data('variant-id');
            console.dir(`variant_id`);console.dir(variant_id);
        }
        
        let properties = new Object();
        let isGiftTemplate = document.querySelector('.template-product-gift');
        if(isGiftTemplate){
            console.log(`%c if(isGiftTemplate){ v0.1`, `color: yellow; font-weight:bold; background-color: red;`);

            let propertiesInputs = document.querySelectorAll('.properties');
            propertiesInputs.forEach((element) => {
                let key = element.getAttribute('data-properties');
                let value = element.value;
                properties[key] = value;
            });
        }
        console.dir(`properties v0.1`);console.dir(properties);

        if(pre_order == true || pre_order == 'true'){
            console.dir(`if(pre_order == true || pre_order == 'true'){`);
            console.log(`%c pre_order_msg_1`, `color: red; font-weight:bold; background-color: yellow;`);
            console.dir(pre_order_msg_1);

            if(pre_order_msg_1 != ' ' && pre_order_msg_1 != 'false' && pre_order_msg_1 != false && pre_order_msg_1 != undefined && pre_order_msg_1.toString().length > 0){
                properties[pre_order_msg_1] = " ";
            }
        }
        addFinalSaleProperty(this, properties);

        if(variant_id != undefined && variant_id.toString().length > 0){
                console.dir(`Add variant_id...`);

                let variantObj = new Object();
                variantObj['id'] = variant_id;
                variantObj['quantity'] = 1;
                if(!isObjectEmpty(properties)){
                    variantObj['properties'] = properties;
                }

                let variantsArr = [];
                variantsArr.push(variantObj);

                addMultiItemsToCart(variantsArr, addToCartPost);
            }
            else {
                console.dir(`Add product_id...`);
                let variantObj = new Object();
                variantObj['id'] = variant_id;
                variantObj['quantity'] = 1;
                if(!isObjectEmpty(properties)){
                    variantObj['properties'] = properties;
                }

                let variantsArr = [];
                variantsArr.push(variantObj);

                addMultiItemsToCart(variantsArr, addToCartPost);
        }
        
    });

    // Set Size Chart images
    const sizes_img_xxs = jQuery('.table-wrapper.size-guide__table-wrapper').data('img-xxs');
    const sizes_img_xs = jQuery('.table-wrapper.size-guide__table-wrapper').data('img-xs');
    const sizes_img_s = jQuery('.table-wrapper.size-guide__table-wrapper').data('img-s');
    const sizes_img_m = jQuery('.table-wrapper.size-guide__table-wrapper').data('img-m');
    const sizes_img_l = jQuery('.table-wrapper.size-guide__table-wrapper').data('img-l');
    const sizes_img_xl = jQuery('.table-wrapper.size-guide__table-wrapper').data('img-xl');
    const sizes_img_xxl = jQuery('.table-wrapper.size-guide__table-wrapper').data('img-xxl');
    const sizes_img_xxxl = jQuery('.table-wrapper.size-guide__table-wrapper').data('img-xxxl');

    jQuery('.table-wrapper.size-guide__table-wrapper .table tr img').each(function(index) {
        
        switch (index) {
            case 0:
                jQuery(this).attr('src', sizes_img_xxs);
                jQuery(this).attr('height', 75);
              break;
            case 1:
                jQuery(this).attr('src', sizes_img_xs);
                jQuery(this).attr('height', 77);
              break;
            case 2:
                jQuery(this).attr('src', sizes_img_s);
                jQuery(this).attr('height', 87);
              break;
            case 3:
                jQuery(this).attr('src', sizes_img_m);
                jQuery(this).attr('height', 97);
              break;
            case 4:
                jQuery(this).attr('src', sizes_img_l);
                jQuery(this).attr('height', 107);
              break;
            case 5:
                jQuery(this).attr('src', sizes_img_xl);
                jQuery(this).attr('height', 117);
              break;
            case 6:
                jQuery(this).attr('src', sizes_img_xxl);
                jQuery(this).attr('height', 127);
              break;
            case 7:
                jQuery(this).attr('src', sizes_img_xxxl);
                jQuery(this).attr('height', 127);
              break;
            default:
                console.log('Error No such image!');
                console.dir(`index`);console.dir(index);
                jQuery(this).attr('src', sizes_img_xxs);
              break;
        }

    });
    // Set Size Chart images END
    //Product page END

    //Recover password
    jQuery('body').on('click', '#recover-link', function(){
        jQuery('#recover-password').removeClass('hide-dom');
        jQuery('#sign-in-form').addClass('hide-dom');
    });

    jQuery('body').on('click', '#recover-cancel', function(){
        jQuery('#recover-password').addClass('hide-dom');
        jQuery('#sign-in-form').removeClass('hide-dom');
    });

    if(window.location.pathname == '/account/login' && window.location.hash == '#recover'){
        jQuery('#recover-password').removeClass('hide-dom');
        jQuery('#sign-in-form').addClass('hide-dom');
    }
    //Recover password END

    jQuery('body').on('click', '.btn-address-delete', function(){
        event.preventDefault();
        jQuery('.loader-search').removeClass('hide');
        var address_url = jQuery(this).parent().attr('action');
        var formData = jQuery(this).parent().serialize();
        jQuery.ajax({
            type: 'POST',
            url: address_url,
            data: formData,
            // dataType: 'json',
            crossDomain: true,
            success: function(response) {
                console.dir(`success`);
                selectorId = 'address-row';
                let url = window.location.origin + window.location.pathname + window.location.hash;
                var finalCallback = () => {
                    hideFormShowAdresses();
                    jQuery('.loader-search').addClass('hide');
                }
                renderSectionFromFetchById(url, selectorId, finalCallback, liveUpdateBlockById);
            },
            error: function (jqXHR, exception) {
                console.dir('error function');
                jQuery('.loader-search').addClass('hide');
                var msg = '';
                if (jqXHR.status === 0) {
                    msg = 'Not connect.\n Verify Network.';
                } else if (jqXHR.status == 404) {
                    msg = 'Requested page not found. [404]';
                } else if (jqXHR.status == 500) {
                    msg = 'Internal Server Error [500].';
                } else if (exception === 'parsererror') {
                    msg = 'Requested JSON parse failed.';
                } else if (exception === 'timeout') {
                    msg = 'Time out error.';
                } else if (exception === 'abort') {
                    msg = 'Ajax request aborted.';
                } else {
                    msg = 'Uncaught Error.\n' + jqXHR.responseText;
                }
                console.dir('msg');
                console.dir(msg);
                console.dir('jqXHR');
                console.dir(jqXHR);
                console.dir('exception');
                console.dir(exception);
                // Your error handling logic here.
              }
        });
    });

    jQuery('body').on('click', '.btn-address-add', function(){
        event.preventDefault();
        jQuery('.loader-search').removeClass('hide');
        var address_url = jQuery(this).closest('form').attr('action');
        var formData = jQuery(this).closest('form').serialize();
        jQuery.ajax({
            type: 'POST',
            url: address_url,
            data: formData,
            // dataType: 'json',
            crossDomain: true,
            success: function(response) {
                console.dir(`success`);
                selectorId = 'address-tab';
                let url = window.location.origin + window.location.pathname + window.location.hash;
                var finalCallback = () => {
                    hideFormShowAdresses();
                    jQuery('.loader-search').addClass('hide');
                }
                renderSectionFromFetchById(url, selectorId, finalCallback, liveUpdateBlockById);
            },
            error: function (jqXHR, exception) {
                console.dir('error function');
                jQuery('.loader-search').addClass('hide');
                var msg = '';
                if (jqXHR.status === 0) {
                    msg = 'Not connect.\n Verify Network.';
                } else if (jqXHR.status == 404) {
                    msg = 'Requested page not found. [404]';
                } else if (jqXHR.status == 500) {
                    msg = 'Internal Server Error [500].';
                } else if (exception === 'parsererror') {
                    msg = 'Requested JSON parse failed.';
                } else if (exception === 'timeout') {
                    msg = 'Time out error.';
                } else if (exception === 'abort') {
                    msg = 'Ajax request aborted.';
                } else {
                    msg = 'Uncaught Error.\n' + jqXHR.responseText;
                }
                console.dir('msg');
                console.dir(msg);
                console.dir('jqXHR');
                console.dir(jqXHR);
                console.dir('exception');
                console.dir(exception);
                // Your error handling logic here.
              }
        });
    });

    jQuery('[data-search]').on('keyup', function() {
        var searchVal = jQuery(this).val();
        var filterItems = jQuery('[data-filter-item]');
        if ( searchVal != '' ) {
            filterItems.addClass('hidden');
            jQuery('[data-filter-item][data-filter-name*="' + searchVal.toLowerCase() + '"]').removeClass('hidden');
        } else {
            filterItems.removeClass('hidden');
        }
    });

    jQuery('.section-store-finder .search-form .btn-search').on('click', function() {
        var searchVal = jQuery(this).parent().find('[data-search]').val();
        var filterItems = jQuery('[data-filter-item]');
        if ( searchVal != '' ) {
            filterItems.addClass('hidden');
            jQuery('[data-filter-item][data-filter-name*="' + searchVal.toLowerCase() + '"]').removeClass('hidden');
        } else {
            filterItems.removeClass('hidden');
        }
    });

    //Gift Card ###
    let defaultAmount = jQuery('#product-amount li.active').data('value');
    jQuery('#visual-amount').text(defaultAmount);
    jQuery('body').on('click', '#product-amount li', function(){
        let value = jQuery(this).data('value');
        let price = jQuery(this).data('price');
        let compare_at_price = jQuery(this).data('compare_at_price');
        jQuery('#visual-amount').text(value);

        let sortBySelect = document.getElementById('product-size');; 
        sortBySelect.value = value; 
        sortBySelect.dispatchEvent(new Event("change"));

        jQuery('.add-to-cart .price').text(price);
        jQuery('.add-to-cart .price-old').text(compare_at_price);
    });

    //Check form fields
    jQuery("body").on('input', '.form-error', function(){
        console.dir(`.form-error input`);
        var fieldLength = jQuery(this).val().length;
        var minLength = +jQuery(this).data('min');
        if(fieldLength >= minLength){
            jQuery(this).removeClass('form-error');
        }
    });

    //Gift Card END ###

    // jQuery('body').on('click', '#product-size-btn', function(){
    //     let offsetTop = jQuery(this).offset().top;
    //     console.dir(`offsetTop`);console.dir(offsetTop);
    //     let scrollTop = jQuery(window).scrollTop();
    //     console.dir(`scrollTop`);console.dir(scrollTop);
    //     let buttonTopCoordinate = offsetTop - scrollTop;
    //     console.log('Top coordinate of the button:', buttonTopCoordinate);

    //     let sizesSelectPopup = jQuery('#sizes-select-popup');
    //     let liElements = sizesSelectPopup.find('.sizes-select-popup-list li');
    //     if(liElements.length > 1){
    //         // Отримати висоту sizesSelectPopup
    //         let popupHeight = sizesSelectPopup.outerHeight();
    //         console.dir(`popupHeight`);console.dir(popupHeight);

    //         // Відняти висоту sizesSelectPopup від buttonTopCoordinate
    //         let newTopCoordinate = buttonTopCoordinate - popupHeight;
    //         // let newTopCoordinate = buttonTopCoordinate;
    //         console.dir(`newTopCoordinate`);console.dir(newTopCoordinate);

    //         // Встановити нове значення top координати для sizesSelectPopup
    //         sizesSelectPopup.css('top', newTopCoordinate + 'px');

    //         sizesSelectPopup.removeClass('hide-dom');
    //         jQuery('.bg-gray-sizes-popup').fadeIn();
    //     }
    // });

    jQuery('body').on('click', '#add-to-cart-waitlist', function(){
        let sizesSelectPopup = jQuery('#sizes-select-popup');
        let liElements = sizesSelectPopup.find('.sizes-select-popup-list li');
        if(liElements.length > 1){
            let button = jQuery('#product-size-btn');
            let buttonOffset = button.offset();
            let buttonHeight = button.outerHeight();
            let popupHeight = sizesSelectPopup.outerHeight();

            // Встановити нове значення top координати для sizesSelectPopup
            let newTopCoordinate = (buttonOffset.top - popupHeight) - 5;

            sizesSelectPopup.css('top', newTopCoordinate + 'px');
            sizesSelectPopup.removeClass('hide-dom');
            jQuery('.bg-gray-sizes-popup').fadeIn();
        } else {
            let BIS_trigger = jQuery('body').find('#BIS_trigger');
            BIS_trigger.trigger('click');
        }
    });

    jQuery('body').on('click', '#product-size-btn', function(){
        let sizesSelectPopup = jQuery('#sizes-select-popup');
        let liElements = sizesSelectPopup.find('.sizes-select-popup-list li');
        if(liElements.length > 1){
            let button = jQuery(this);
            let buttonOffset = button.offset();
            let buttonHeight = button.outerHeight();
            let popupHeight = sizesSelectPopup.outerHeight();

            // Встановити нове значення top координати для sizesSelectPopup
            let newTopCoordinate = (buttonOffset.top - popupHeight) - 5;

            sizesSelectPopup.css('top', newTopCoordinate + 'px');
            sizesSelectPopup.removeClass('hide-dom');
            jQuery('.bg-gray-sizes-popup').fadeIn();
        }
    });

    jQuery('body').on('click', '#product-size-btn-sticky', function(){
        let sizesSelectPopup = jQuery('#sizes-select-popup-sticky');
        let liElements = sizesSelectPopup.find('.sizes-select-popup-list li');
        if(liElements.length > 1){
            jQuery('#sizes-select-popup-sticky').removeClass('hide');
            jQuery('.bg-gray-sizes-popup-sticky').fadeIn();
        }
    });

    jQuery('body').on('click', '#sizes-select-popup li.available', function(){        
        jQuery(this).siblings().removeClass('selected');
        jQuery(this).addClass('selected');

        let variant_id = jQuery(this).data('variant-id');
        let other_li_selector = '#sizes-select-popup-sticky li[data-variant-id="'+variant_id+'"]';
        jQuery(other_li_selector).siblings().removeClass('selected');
        jQuery(other_li_selector).addClass('selected');

        let value = jQuery(this).find('div.size-value').text();
        jQuery('#product-size-btn').text(value);
        jQuery('#product-size-btn-sticky').text(value);
        let price = jQuery(this).data('price');
        let compare_at_price = jQuery(this).data('compare_at_price');
        let title = jQuery(this).data('title');
        jQuery('.add-to-cart .price').text(price);
        jQuery('.add-to-cart .price-old').text(compare_at_price);
        jQuery('.sticky-to-cart__price').text(price);
        jQuery('.sticky-to-cart__price-old').text(compare_at_price);

        let pre_order = jQuery(this).data('pre-order');
        if(pre_order == true || pre_order == 'true'){
            let pre_order_button_text = jQuery(this).data('pre-order-button-text');
            jQuery('#add-to-cart-statick-text').text(pre_order_button_text);
            jQuery('#sticky-to-cart-text').text(pre_order_button_text);
        } else {
            let add_to_cart_button_text = jQuery(this).data('pre-order-add-to-cart-text');
            jQuery('#add-to-cart-statick-text').text(add_to_cart_button_text);
            jQuery('#sticky-to-cart-text').text(add_to_cart_button_text);
        }

        // jQuery('.section-sticky .variant-title').text(title);
        jQuery('#sizes-select-popup').addClass('hide-dom');
        jQuery('.bg-gray-sizes-popup').fadeOut();
    });

    jQuery('body').on('click', '#sizes-select-popup-sticky li.available', function(){
        console.log(`%c jQuery('body').on('click', '#sizes-select-popup-sticky li.available', function(){`, `color: red; font-weight:bold; background-color: yellow;`);

        jQuery(this).siblings().removeClass('selected');
        jQuery(this).addClass('selected');

        let variant_id = jQuery(this).data('variant-id');
        let other_li_selector = '#sizes-select-popup li[data-variant-id="'+variant_id+'"]';
        jQuery(other_li_selector).siblings().removeClass('selected');
        jQuery(other_li_selector).addClass('selected');

        let value = jQuery(this).find('div.size-value').text();
        jQuery('#product-size-btn').text(value);
        jQuery('#product-size-btn-sticky').text(value);
        let price = jQuery(this).data('price');
        let compare_at_price = jQuery(this).data('compare_at_price');
        let title = jQuery(this).data('title');
        jQuery('.add-to-cart .price').text(price);
        jQuery('.add-to-cart .price-old').text(compare_at_price);
        jQuery('.sticky-to-cart__price').text(price);
        jQuery('.sticky-to-cart__price-old').text(compare_at_price);
        // jQuery('.section-sticky .variant-title').text(title);

        let pre_order = jQuery(this).data('pre-order');
        console.log('%c pre_order', 'color: red; font-weight:bold; background-color: yellow;');
        console.dir(pre_order);

        if(pre_order == true || pre_order == 'true'){
            console.dir(`if(pre_order == true || pre_order == 'true'){`);

            let pre_order_button_text = jQuery(this).data('pre-order-button-text');
            console.log('%c pre_order_button_text', 'color: navy; font-weight:bold; background-color: yellow;');
            console.dir(pre_order_button_text);


            jQuery('#add-to-cart-statick-text').text(pre_order_button_text);
            jQuery('#sticky-to-cart-text').text(pre_order_button_text);
        } else {
            console.dir(`if(pre_order == true || pre_order == 'true'){} else {`);

            let add_to_cart_button_text = jQuery(this).data('pre-order-add-to-cart-text');
            console.log('%c pre_order_button_text', 'color: navy; font-weight:bold; background-color: yellow;');
            console.dir(add_to_cart_button_text);

            jQuery('#add-to-cart-statick-text').text(add_to_cart_button_text);
            jQuery('#sticky-to-cart-text').text(add_to_cart_button_text);
        }

        jQuery('#sizes-select-popup-sticky').addClass('hide');
        jQuery('.bg-gray-sizes-popup-sticky').fadeOut();
    });


    if (jQuery('.bg-gray-sizes-popup').length) {
        jQuery('body').on('click', '.bg-gray-sizes-popup', function(){
            jQuery('#sizes-select-popup').addClass('hide-dom');
            jQuery('.bg-gray-sizes-popup').fadeOut();
        });
    }

    if (jQuery('.bg-gray-sizes-popup-sticky').length) {
        jQuery('body').on('click', '.bg-gray-sizes-popup-sticky', function(){
            jQuery('#sizes-select-popup-sticky').addClass('hide');
            jQuery('.bg-gray-sizes-popup-sticky').fadeOut();
        });
    }

    jQuery('body').on('click', '.check-include', function(){
        if(jQuery(this).closest('.cross-sell').find('.cross-sell-sizes-list').length>0) {
            jQuery(this).parent().addClass('hide-dom');
            jQuery(this).closest('.cross-sell').find('.cross-sell-sizes').removeClass('hide-dom');
        }
        else {
            let variant_id = jQuery(this).data('variant_id');
            let variantsArr = [
                {
                    "id": variant_id,
                    "quantity": 1
                }
            ];
            addMultiItemsToCart(variantsArr, addToCartPost);
        }
    });

    jQuery('body').on('click', '.cross-sell-sizes-list li.available', function(){
        let variant_id = jQuery(this).data('variant-id');
        let variantsArr = [
                {
                    "id": variant_id,
                    "quantity": 1
                }
            ];
        let showHide = () => {
                jQuery(this).closest('.cross-sell').find('.cross-sell-sizes').addClass('hide-dom');
                jQuery(this).closest('.cross-sell').find('.check-include-wrapper').removeClass('hide-dom');
            };
        let addToCart = (variantsArr, callback) => {
                addMultiItemsToCart(variantsArr, addToCartPost);
                callback();
            };
        addToCart(variantsArr, showHide);
    });

    /* section-sticky ### */
    if( (jQuery('#add-to-cart-statick').length && jQuery('#section-sticky').length) || (jQuery('#add-to-cart-statick').length && jQuery('#sticky-to-cart').length) ){
        // Получаем нужный элемент
        var addToCartStatick = document.getElementById('add-to-cart-statick');
        // var element = document.querySelector('#target');

        var Visible = function (target) {
            // Все позиции элемента
            var targetPosition = {
                    top: window.pageYOffset + target.getBoundingClientRect().top,
                    left: window.pageXOffset + target.getBoundingClientRect().left,
                    right: window.pageXOffset + target.getBoundingClientRect().right,
                    bottom: window.pageYOffset + target.getBoundingClientRect().bottom
                },
                // Получаем позиции окна
                windowPosition = {
                    top: window.pageYOffset,
                    left: window.pageXOffset,
                    right: window.pageXOffset + document.documentElement.clientWidth,
                    bottom: window.pageYOffset + document.documentElement.clientHeight
                };

                let getTolerancePixel = () => {
                    let getHeight = (element) => {
                        return element ? element.offsetHeight : 0;
                    };
                    let headerMenu = document.querySelector('.header-main');
                    return getHeight(headerMenu);
                }
                let tolerancePixel = getTolerancePixel();

            if (targetPosition.bottom < (windowPosition.top + tolerancePixel)) { 
                jQuery('#sticky-to-cart').removeClass('animate-hidden');
                // setTimeout(function(){
                    document.body.classList.add('sticky-to-cart-show');
                // }, 1000);
            } else {
                jQuery('#sticky-to-cart').addClass('animate-hidden');
                document.body.classList.remove('sticky-to-cart-show');
            };
        };

        // Запускаем функцию при прокрутке страницы
        window.addEventListener('scroll', function() {
            Visible(addToCartStatick);
        });

        // А также запустим функцию сразу. А то вдруг, элемент изначально видно
        Visible(addToCartStatick);
    }
    /* section-sticky END */

     /* Get product-thumbnail__swatch from product page */
    jQuery('body').find('.product-thumbnail__swatch').each(function(index){
        let getProduct = jQuery(this).data('get-product');
        if(getProduct == false || getProduct == 'false'){
           let productHandle = jQuery(this).data('product-handle');
           let view = '?view=color';
           let productUrl = window.location.origin+`/products/`+productHandle;
           let productUrlView = window.location.origin+`/products/`+productHandle+view;
           let getImgSrc = (html) => {
                if(html){
                    let colorImageUrl = new DOMParser().parseFromString(html, 'text/html').getElementById('self-color').innerHTML;
                    jQuery(this).attr('href', productUrl);
                    jQuery(this).find('span').attr('style', `background-image:url(${colorImageUrl});background-size: cover`);
                }
                else {
                    jQuery(this).parent().remove();
                }
           };
           renderSectionFromFetch(productUrlView, getImgSrc);
        }
      });
    /* Get product-thumbnail__swatch from product page END */

    /* Video Landing Section ######### */
        /* Custom Video Play button */

    function isiPhone() {
        return /iPhone|iPod/i.test(navigator.userAgent);
      }
  
      function loopVideoSections(){
  
        let videoSections = document.querySelectorAll('.video-landing');
        for (let i = 0; i < videoSections.length; ++i) {
          let videoSection = videoSections[i];
  
          let videoPlayer = videoSection.querySelector('.video-player');
          let video = videoPlayer.querySelector('.video');
          let playButton = videoPlayer.querySelector('.play-button');
          let playerControlsWrapper = videoPlayer.querySelector('.player-controls-wrapper');
  
          playerControlsWrapper.addEventListener('click', (e) => {
            if(video.paused){
              // playerControlsWrapper.classList.remove("bg-black");
              playerControlsWrapper.style.backgroundImage = '';
              video.play();
              // playerControlsWrapper.classList.add("hide");
              playButton.classList.add("hide");
            } else {
              video.pause();
            }
          });
  
          video.addEventListener("pause", (event) => {
            playerControlsWrapper.classList.remove("hide");
            playButton.classList.remove("hide");
  
            if(isiPhone()) {
              // playerControlsWrapper.classList.add("bg-black");
              let canvas = document.createElement('canvas');
              canvas.width = video.videoWidth;
              canvas.height = video.videoHeight;
              let context = canvas.getContext('2d');
              context.drawImage(video, 0, 0, canvas.width, canvas.height);
              let poster = canvas.toDataURL();
              playerControlsWrapper.style.backgroundImage = 'url("' + poster + '")';
              playerControlsWrapper.style.backgroundRepeat = 'no-repeat';
              playerControlsWrapper.style.backgroundSize = 'cover';
              context.clearRect(0, 0, canvas.width, canvas.height);
            }
          });
      
          video.addEventListener("ended", (event) => {
            playerControlsWrapper.classList.remove("hide");
            playButton.classList.remove("hide");
            if(isiPhone()) {
              // playerControlsWrapper.classList.add("bg-black");
              let poster = video.getAttribute('poster');
              playerControlsWrapper.style.backgroundImage = 'url("' + poster + '")';
              playerControlsWrapper.style.backgroundRepeat = 'no-repeat';
              playerControlsWrapper.style.backgroundSize = 'cover';
            }
          });
      
        }
    
      }
      loopVideoSections();
  
      /* Custom Video Play button END */  
    /* Video Landing Section END ##### */

    /* Show color image on hover in product card */

    jQuery("body").on({
        mouseenter: function () {
            let $element = jQuery(this).closest('.item').find('.img-wrapper');
            let height = $element.height();
            $element.css('height', height);
            let newImg = jQuery(this).attr('data-product-img');
            jQuery(this).closest('.item').find('.product__image.product__image-first').attr('src', newImg);
        },
        mouseleave: function () {
        //stuff
            let featuredImage = jQuery(this).closest('.item').find('.product__image.product__image-first').attr('data-flickity-lazyload');
            jQuery(this).closest('.item').find('.product__image.product__image-first').attr('src', featuredImage);
        }
    }, ".product-thumbnail__swatch"); 

    /* Show color image on hover in product card END */

    /* Mobile filter toggle */
    if(jQuery('.facets-mobile-header').length){
        let isOpen = localStorage.getItem("mobile-filters-open");
        if(isOpen === "open") {
            let this_obj = '.facets-mobile-header';
            jQuery(this_obj).addClass('open');
            jQuery(this_obj).siblings('.facets').removeClass('facets-mobile-hide');
        }
        
        jQuery('body').on('click', '.facets-mobile-header', function(){
            if(!jQuery(this).hasClass('open')){
                localStorage.setItem("mobile-filters-open", "open");
            } else {
                localStorage.setItem("mobile-filters-open", "close");
            }
            jQuery(this).siblings('.facets').toggleClass('facets-mobile-hide');
            jQuery(this).toggleClass('open');
        });
    }
    /* Mobile filter toggle END */

    /* About page shop menu */
    if(jQuery('.about-menu__li').length){

        jQuery('body').on('click', '.about-menu__parent-arrow', function(){
            if (document.documentElement.clientWidth > 991) {
                jQuery(this).closest('.about-menu__li').toggleClass('open');
                jQuery(this).closest('.about-menu__li').siblings('.about-menu__li.open').removeClass('open');
            } else {
                jQuery(this).closest('.about-menu-mobile__li').toggleClass('open');
                jQuery(this).closest('.about-menu-mobile__li').siblings('.about-menu-mobile__li.open').removeClass('open');
            }
        });

        jQuery('body').on('click', '.about-menu__a-parent', function(){
            if (document.documentElement.clientWidth > 991) {
                jQuery(this).closest('.about-menu__li').toggleClass('open');
                jQuery(this).closest('.about-menu__li').siblings('.about-menu__li.open').removeClass('open');
            } else {
                jQuery(this).closest('.about-menu-mobile__li').toggleClass('open');
                jQuery(this).closest('.about-menu-mobile__li').siblings('.about-menu-mobile__li.open').removeClass('open');
            }
        });

        jQuery("body").on({
            mouseenter: function () {
                let index = jQuery(this).attr('data-link-handle');
                let selector = `.main-menu__sub1-bg-img-${index}`;
                jQuery(selector).siblings().removeClass('opacity-1');
                let isSelectedImage = jQuery(selector).attr('data-is-image');
                if(isSelectedImage == 'true' || isSelectedImage == true){
                    jQuery(selector).addClass('opacity-1');
                    jQuery('.main-menu__sub1-col-1').addClass('left-border');
                }
            },
            mouseleave: function () {
            //stuff
            }
        }, ".about-menu__li");

        jQuery("body").on({
            mouseenter: function () {
                $('.main-menu__sub1-bg-img').each(function() {
                    let bgImage = $(this).attr('data-bg-image');
                    $(this).css('background-image', 'url(' + bgImage + ')');
                });
            },
            mouseleave: function () {
                // jQuery(this).find('.main-menu__sub1-bg-img').removeClass('opacity-1');
            }
        }, ".main-menu__parrent");
    }
    
    /* About page shop menu END */

    /* Zoom product images */

    function zoomAllProductImages(selector){
        let zoomImageContainers = document.querySelectorAll(selector);
        for (let i = 0; i < zoomImageContainers.length; ++i) {
            let zoomImageContainer = zoomImageContainers[i];
            let statickImage = zoomImageContainer.querySelector('.zoom-image');
            let zoomImage = zoomImageContainer.querySelector('.zoom-image-big');
            let imageUrl = zoomImage.getAttribute('data-zoom-src');
            zoomImage.setAttribute('src', imageUrl);

            let width = statickImage.offsetWidth;
            let height = statickImage.offsetHeight;

            let options = {
                zoomPosition:'right',
                fillContainer: true,
                zoomStyle: 'z-index:2;',
                offset: {vertical: 0, horizontal: 6},
                zoomFactor: 2,
                lensScale: 0.5
            };
            new ImageZoom(zoomImageContainer, options); 
        }
    }

    function whenProductImagesLoaded(selector){
        let $selector = jQuery(selector);
        let $images = $selector.find('img.zoom-image');
        let imgCount = $images.length;
        let counter = 0;
        $images.each(function(){
            if(this.complete){
                imageLoaded(this);
            }
            else{
                jQuery(this).one('load', function(){
                    imageLoaded(this);
                });
            }
        });
        function imageLoaded(this_obj){
            counter++;
            if(counter == imgCount){
                zoomAllProductImages(selector);
            }
        }
    }
    if(jQuery('body').hasClass('template-product')){
        if(document.documentElement.clientWidth > 991){
            whenProductImagesLoaded('.zoom-image-container');
        }
    }

    /* Zoom product images END */
    
    if(isSafariBrowser()){
        setTimeout(function(){
            // setHeaderBreadcrumbsPosition();
            setTeaserOpacity();
        }, 0);  
    } else {
        // setHeaderBreadcrumbsPosition();
        setTeaserOpacity();
    }

});

/* Lazy-Load bg images by lazysizes */
document.addEventListener('lazybeforeunveil', function(e){
    let bg = e.target.getAttribute('data-bg');
    if(bg){
        e.target.style.backgroundImage = 'url(' + bg + ')';
    }
})
/* Lazy-Load bg images by lazysizes END */

/* Mobile menu */

document.addEventListener('DOMContentLoaded', function() {

    let customNavbarToggler = document.getElementById('customNavbarToggler');
    let customNavbarToggler2 = document.getElementById('customNavbarToggler2');
    let target = document.getElementById('navbarNav');
    let overlay = document.querySelector(".main-menu__overlay-mob"); 
    customNavbarToggler.addEventListener('click', function() {
        if (target.classList.contains('show')) {
            target.classList.remove('show');
            overlay.classList.remove('show');
            customNavbarToggler.classList.add('collapsed');
        } else {
            target.classList.add('show');
            overlay.classList.add('show');
            customNavbarToggler.classList.remove('collapsed');
        }
    });
    customNavbarToggler2.addEventListener('click', function() {
        if (target.classList.contains('show')) {
            target.classList.remove('show');
            overlay.classList.remove('show');
            customNavbarToggler.classList.add('collapsed');
        } else {
            target.classList.add('show');
            overlay.classList.add('show');
            customNavbarToggler.classList.remove('collapsed');
        }
    });
    overlay.addEventListener('click', function() {
        if (target.classList.contains('show')) {
            target.classList.remove('show');
            overlay.classList.remove('show');
            customNavbarToggler.classList.add('collapsed');
        }
    });
});

/* Mobile menu END */

/* Drag to scroll pc horizontal swipe */

window.onload = function() {
    document.body.classList.add('all-loaded');

    let product_card_labels = document.querySelectorAll('.product-card-labels');
    product_card_labels.forEach((element) => {
        element.removeAttribute('style');
    });

    function horizontalPCSwipeScroll(selector){
        let slider = document.querySelector(selector);
        let isDown = false;
        let startX;
        let scrollLeft;
        slider.addEventListener("mousedown", e => {
            isDown = true;
            slider.classList.add("active");
            startX = e.pageX - slider.offsetLeft;
            scrollLeft = slider.scrollLeft;
        });
        slider.addEventListener("mouseleave", () => {
            isDown = false;
            slider.classList.remove("active");
        });
        slider.addEventListener("mouseup", () => {
            isDown = false;
            slider.classList.remove("active");
        });
        slider.addEventListener("mousemove", e => {
            if (!isDown) return;
            e.preventDefault();
            let x = e.pageX - slider.offsetLeft;
            let walk = x - startX;
            slider.scrollLeft = scrollLeft - walk;
        });
    }
  if(jQuery('.ticker.bg-pink').length > 0 ){
    horizontalPCSwipeScroll('.ticker.bg-pink');
  }
  if(jQuery('.ticker.bg-winter').length > 0 ){
    horizontalPCSwipeScroll('.ticker.bg-winter');
  }
  if(jQuery('.ticker.bg-fall').length > 0 ){
    horizontalPCSwipeScroll('.ticker.bg-fall');
  }
  if(jQuery('.ticker.bg-summer').length > 0 ){
    horizontalPCSwipeScroll('.ticker.bg-summer');
  }
    
};

/* Drag to scroll pc horizontal swipe END */

window.addEventListener('scroll', function() {
    let getHeight = (element) => {
        return element ? element.offsetHeight : 0;
    };

    let headerMain = document.getElementById('header-main');

    if (window.scrollY > 0) {
        let heightHeaderMain = getHeight(headerMain);
        let parentHeaderMain = headerMain.parentNode;
        parentHeaderMain.style.height = heightHeaderMain + 'px';

        let tickerSection = document.querySelector('.ticker-section');
        let announcementSection = document.querySelector('.announcement-section');

        let tickerHeight = getHeight(tickerSection);
        let announcementHeight = getHeight(announcementSection);

        let totalHeight = tickerHeight + announcementHeight;
        let transform = 'translateY(-' + totalHeight + 'px)';
        headerMain.style.transition = 'transform 0.3s ease-in-out';
        headerMain.style.transform = transform;

        headerMain.classList.add('sc-fixed');

    } else {
      headerMain.style.transition = 'transform 0.8s ease-in-out';
      headerMain.style.transform = 'translateY(0)';

      headerMain.classList.remove('sc-fixed');
    }
});

console.log(`%c app.js.liquid v0.5`, `color: red; font-weight:bold; background-color: yellow;`);